var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { UserGroup } from 'packages/user_groups/UserGroup';
import { PaginationQuery } from 'common/PaginationQuery';
var UserGroupRepository = /** @class */ (function (_super) {
    __extends(UserGroupRepository, _super);
    function UserGroupRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = UserGroup;
        _this.url = 'api/v2/user/groups';
        return _this;
    }
    UserGroupRepository.prototype.getUserGroups = function (query) {
        return this.getAll(this.url, null, query.queryData).then(function (response) { return response.items; });
    };
    UserGroupRepository.prototype.getUserGroupsPaginated = function (query) {
        return this.getPaginated(this.url, null, query.queryData);
    };
    UserGroupRepository.prototype.getUserGroup = function (groupId, companyId) {
        // This part has to be replaced when BE is ready
        var query = new PaginationQuery();
        query.setFilter('company_id', companyId);
        var allUserGroups = this.getUserGroups(query);
        return allUserGroups.then(function (groups) { return groups.find(function (group) { return group.id === groupId; }); });
    };
    UserGroupRepository.prototype.addObjectToGroup = function (userGroupId, objectType, objectId, companyId) {
        return this.post('api/v2/user/group/objects', {
            user_group_id: userGroupId,
            object_type: objectType,
            object_id: objectId,
            company_id: companyId,
        });
    };
    UserGroupRepository.prototype.removeObjectFromGroup = function (userGroupId, objectTypeName, objectId) {
        return this.axios.delete("api/v2/user/group/" + userGroupId + "/object/" + objectTypeName + "/" + objectId);
    };
    UserGroupRepository.prototype.attachUserToTeam = function (groupId, userId) {
        return this.post(this.url + "/" + groupId + "/" + userId, {});
    };
    UserGroupRepository.prototype.detachUserFromTeam = function (groupId, userId) {
        return this.delete(groupId + "/" + userId);
    };
    UserGroupRepository.prototype.createUserGroup = function (payload) {
        return this.post(this.url, payload);
    };
    UserGroupRepository.prototype.deleteUserGroup = function (groupId) {
        return this.delete(groupId);
    };
    return UserGroupRepository;
}(AbstractRepository));
export { UserGroupRepository };
